/**
 * Centralized z-index system for the application
 *
 * This file provides a single source of truth for all z-index values
 * to prevent layering conflicts and ensure consistent stacking order.
 *
 * Usage:
 * import { Z_INDEX } from '@/lib/constants/z-index'
 * style={{ zIndex: Z_INDEX.MODAL }}
 */

export const Z_INDEX = {
  // Base layers (0-9)
  BASE: 0,

  // Content layers (10-19)
  CARD: 10,
  CARD_HOVER: 15,

  // UI elements (20-29)
  STICKY_HEADER: 20,

  // Navigation (30-49)
  HEADER: 30,
  SIDEBAR_BACKDROP: 39,
  SIDEBAR: 40,

  // Overlays and backdrops (40-49)
  BACKDROP: 45,

  // Dropdowns and popovers (50-59)
  DROPDOWN: 50,
  POPOVER: 55,

  // Modals and dialogs (60-69)
  MODAL_BACKDROP: 60,
  MODAL: 70,

  // Toast notifications (80-89)
  TOAST: 80,

  // Tooltips (90-99)
  TOOLTIP: 90,

  // Critical overlays (100+)
  LOADING_OVERLAY: 100,
} as const

export type ZIndexKey = keyof typeof Z_INDEX
